<template>
  <div :is="$parent.inline ? 'span' : 'div'" :class="[baseCss, $parent.inline ? inlineBlock : null, `text-${fontSize}`, bold ? 'font-semibold' : null, 'truncate']">
    <span :class="[inlineBlock]"><slot name="icon" /></span><!--
    --><span v-if="prefix" v-html="prefix" :class="[inlineBlock]" /><!--
    --><span :class="[inlineBlock]"><slot /></span><!--
    --><span v-if="postfix" v-html="postfix" :class="[inlineBlock]" />
  </div>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'StatsValue',
  mixins: [
    methods
  ],
  data () {
    return {
      inlineBlock: ['inline-block', 'align-middle'],
      baseCss: this.componentBaseCss('stats-value', [])
    }
  },
  props: {
    fontSize: {
      type: String,
      default: 'xl',
      validator: value => {
        return ['xs', 'md', 'sm', 'base', 'lg', 'xl', '2xl', '3xl', '4xl', '5xl', '6xl', '7xl', '8xl', '9xl'].includes(value)
      }
    },
    bold: {
      type: Boolean,
      default: true
    },
    prefix: {
      type: String
    },
    postfix: {
      type: String
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/bcq-ui/components/stats-value/stats-value.vue